<script lang="ts">
  import type { Snippet } from 'svelte'

  let {
    variant = 'default',
    padding = 'md',
    shadow = 'md',
    hover = false,
    onclick,
    class: className = '',
    children,
    ...restProps
  }: {
    variant?: 'default' | 'bordered'
    padding?: 'none' | 'sm' | 'md' | 'lg'
    shadow?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
    hover?: boolean
    onclick?: () => void
    class?: string
    children: Snippet
    [key: string]: unknown
  } = $props()

  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  }

  const shadowClasses = {
    none: '',
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg',
    xl: 'shadow-xl',
  }

  const variantClasses = {
    default: '',
    bordered: 'border border-neutral-200 dark:border-gray-700',
  }

  const hoverClass = $derived(
    hover ? 'hover:shadow-lg transition-shadow duration-200' : ''
  )
  const cursorClass = $derived(onclick ? 'cursor-pointer' : '')
</script>

{#if onclick}
  <button
    class="bg-white dark:bg-gray-800 rounded-lg {paddingClasses[
      padding
    ]} {shadowClasses[shadow]} {variantClasses[
      variant
    ]} {hoverClass} {cursorClass} {className} text-left w-full"
    {onclick}
    type="button"
    {...restProps}
  >
    {@render children()}
  </button>
{:else}
  <div
    class="bg-white dark:bg-gray-800 rounded-lg {paddingClasses[
      padding
    ]} {shadowClasses[shadow]} {variantClasses[
      variant
    ]} {hoverClass} {className}"
    {...restProps}
  >
    {@render children()}
  </div>
{/if}
